<template>
  <v-badge color="red" overlap>
    <template v-slot:badge>
      <template v-if="unreadCounter > 0">
        <span class="caption">{{ unreadCounter }}</span>
      </template>
    </template>
    <v-icon
      medium
    >
      notifications
    </v-icon>
  </v-badge>
</template>

<script>

import {mapState, mapActions} from "vuex";
import STORE from "@/store/STORE";
const getNotificationsUnreadCountFunc = STORE.modules.notifications.actions.getNotificationsUnreadCount;

export default {
  name: 'notificationBadge',
  data() {
    return {
      timerId: null,
    }
  },
  async mounted() {
    await this[getNotificationsUnreadCountFunc]();
    if (this.timerId) return;

    this.timerId = setInterval(() => {
      this[getNotificationsUnreadCountFunc]();
    }, 30*1000);
  },
  methods: {
    ...mapActions('notifications', [getNotificationsUnreadCountFunc]),
  },
  computed: {
    ...mapState('notifications', ['unreadCounter'])
  },

};
</script>
